export class ContractVinCancelRequest {

    contractId: number;
    vin: string;
}